import WelcomeImg from './welcome.svg';
import AuthBgImage from "./auth-bg-image.svg";
import IconLogo from "./logos/icon-logo.svg";
import CyStackImg from './logos/CyStack.png';
import AuthLogoImg from './logos/auth-logo.svg';
import IntroImg from './pages/quick-share-detail/intro.png';
import NoDataImg from './data/no-data.svg';

export default {
  WelcomeImg,
  AuthBgImage,
  IconLogo,
  CyStackImg,
  AuthLogoImg,
  IntroImg,
  NoDataImg
}